module.exports = __webpack_public_path__ + "img/email.c67d21b0.svg";